import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { Label, LabelProps } from "reactstrap";

export interface ControlLabelProps extends LabelProps {
    controlStyles?: IControlStyles | undefined;
    isOptional?: boolean | undefined;
    tooltip?: string | undefined;
    required?: boolean | undefined;
}

function FormatisOptional(isOptional?: boolean): string {
    if (isOptional ?? false) {
        return "(optional)";
    }

    return "";
}

const ComponentProps = (props: ControlLabelProps): LabelProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;
    delete componentProps.isOptional;
    delete componentProps.tooltip;
    delete componentProps.required;

    return componentProps;
}

export const ControlLabel: React.FC<ControlLabelProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();

    return (
        <Label {...ComponentProps(props)} style={{ ...styles.label ?? styles.input, ...props.style }}>
            {props.children}
            {props.required && (
                <span aria-hidden="true" style={{ color: "var(--color-danger)", marginLeft: 4 }}>*</span>
            )}
            {" "}<span style={{ ...styles.optional }}>{FormatisOptional(props.isOptional)}</span>
        </Label>
    );
};